var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"dark":_vm.dark,"persistent":_vm.persistent,"width":_vm.width,"max-width":"100%","value":_vm.show},on:{"click:outside":_vm.onClickOutside}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }